import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { client } from "~/utils/medproSDK";
import AppId from "~/utils/partner";
import { currentEnv } from "~/configs";
import { handleClearAndLogout } from "~/api/axios.config";
import { upgradeLegacyTokenApi } from "~/store/login/loginApi";
import { updateUserToken } from "~/store/user/userAction";
import { getKeyCookie, setKeyCookie } from "~/utils/func";

const RESTFULL_API_URL = currentEnv.RESTFULL_API_URL;

/**
 * Giải mã JWT để lấy payload
 */
export function decodeJwt(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
}

/**
 * Hook tự động di trú, đồng bộ hóa và làm mới Token để bảo vệ phiên làm việc.
 * Trả về `isMigrating = true` khi đang xác thực và `false` khi đã sẵn sàng.
 */
export function useLegacyTokenMigrator() {
  const [isMigrating, setIsMigrating] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    async function checkAndInitializeToken() {
      try {
        const pathname = window.location.pathname;
        const isLoginRoute = pathname.startsWith("/login");

        const token =
          getKeyCookie("token") || window.localStorage.getItem("jwt");
        const refreshToken =
          getKeyCookie("refreshToken") ||
          window.localStorage.getItem("refreshToken");

        // 1. Trường hợp có token nhưng chưa có refreshToken (Legacy Session cũ) -> Nâng cấp token
        if (token && !refreshToken) {
          try {
            const response = await upgradeLegacyTokenApi(RESTFULL_API_URL, {
              headers: {
                Authorization: `Bearer ${token}`,
                appid: AppId,
                partnerid: AppId
              }
            });
            const { token: newToken, refreshToken: newRefreshToken } =
              response?.data || {};

            setKeyCookie("token", newToken);
            setKeyCookie("refreshToken", newRefreshToken);

            // Dọn dẹp localStorage cũ và lưu token mới thay thế
            window.localStorage.removeItem("token");
            window.localStorage.removeItem("refreshToken");
            window.localStorage.setItem("jwt", newToken);

            if (client) {
              client.setToken(newToken);
            }

            dispatch(updateUserToken(newToken));
          } catch (upgradeError) {
            if (!isLoginRoute) {
              handleClearAndLogout();
            }
          }
        } else if (token) {
          if (client) {
            client.setToken(token);
          }
        }
        // 2. Trường hợp không có cả token và refreshToken
        else {
          // Bỏ qua dọn dẹp và chuyển hướng nếu đang ở trang đăng nhập
          if (!isLoginRoute) {
            handleClearAndLogout();
          }
        }
      } catch (error) {
        handleClearAndLogout();
      } finally {
        setIsMigrating(false);
      }
    }

    checkAndInitializeToken();
  }, []);

  return { isMigrating };
}
